import React from "react"
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Card, CardContent, CardHeader, Grid, Tooltip, Typography } from "@material-ui/core";
import { Tickets, RSSITickets, CreateNewTicket, FileExplorer } from './components'

const useStyles = (fileviwerOpen = false) => {
    const generateStyle = (theme) => {
        var style = {
            rootDesktop: {
                marginTop: theme.spacing(2),
                marginLeft: theme.spacing(4),
                marginRight: theme.spacing(4),
            },
            rootTablet: {
                marginTop: theme.spacing(2),
                marginLeft: theme.spacing(5),
                marginRight: theme.spacing(5),
            },
            rootMobile: {
                marginTop: theme.spacing(1),
                marginLeft: theme.spacing(1),
                marginRight: theme.spacing(1),
            },
        }
        if (fileviwerOpen) {
            style = {
                ...style,
                rootDesktop: {
                    ...style.rootDesktop,
                    display: "none"
                },
                rootTablet: {
                    ...style.rootTablet,
                    display: "none"
                },
            }
        }
        return style
    }
    return makeStyles((theme) => generateStyle(theme))()
}

const viewState = { DASHBOARD: "DASHBOARD", CREATE_NEW_TICKET_VIEW: "CREATE_NEW_TICKET_VIEW" }
const ticketTypes = { GENERAL: "GENERAL", RSSI: "RSSI" }

const HomePage = ({ responsive, profile }) => {
    const [view, setView] = React.useState(viewState.DASHBOARD)
    const [ticketType, setTicketType] = React.useState(ticketTypes.GENERAL)
    const [fileExplorerData, setFileExplorerData] = React.useState({})
    const classes = useStyles(Object.keys(fileExplorerData).length !== 0)
    const readOnly = useSelector((state) => state.app.readOnly)

    const readOnlyTooltip = "The old portal is read-only. Migrate to the new ESP app to create tickets."

    return (
        <React.Fragment>
            <Card className={responsive.isDesktopOrLaptop ? classes.rootDesktop : responsive.isTablet ? classes.rootTablet : responsive.isMobile ? classes.rootMobile : classes.rootDesktop}>
                <CardHeader style={{ paddingTop: 5, paddingBottom: 0 }}
                    title={
                        <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                            <Grid item><Button style={{ paddingLeft: 5, paddingRight: 5 }} variant={view === viewState.DASHBOARD ? "contained" : "text"} color={view === viewState.DASHBOARD ? "primary" : "inherit"} size="small" onClick={() => setView(viewState.DASHBOARD)}><Typography variant="h6" color="textSecondary">Dashboard</Typography></Button></Grid>
                            <Grid item>
                                <Tooltip title={readOnly ? readOnlyTooltip : ""}>
                                    <span>
                                        <Button style={{ paddingLeft: 5, paddingRight: 5 }} disabled={readOnly} variant={view === viewState.CREATE_NEW_TICKET_VIEW ? "contained" : "text"} color={view === viewState.CREATE_NEW_TICKET_VIEW ? "primary" : "inherit"} size="small" onClick={() => setView(viewState.CREATE_NEW_TICKET_VIEW)}><Typography variant="h6" color="textSecondary">Create New Ticket</Typography></Button>
                                    </span>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    }
                    subheader={
                        view === viewState.DASHBOARD && ["superadmin", "admin"].includes(profile.accesslvl) ? (
                            <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                                <Grid item><Button style={{ paddingLeft: 5, paddingRight: 5 }} variant={ticketType === ticketTypes.GENERAL ? "contained" : "text"} color={ticketType === ticketTypes.GENERAL ? "primary" : "inherit"} size="small" onClick={() => setTicketType(ticketTypes.GENERAL)}><Typography variant="h6" color="textSecondary">General</Typography></Button></Grid>
                                <Grid item><Button style={{ paddingLeft: 5, paddingRight: 5 }} variant={ticketType === ticketTypes.RSSI ? "contained" : "text"} color={ticketType === ticketTypes.RSSI ? "primary" : "inherit"} size="small" onClick={() => setTicketType(ticketTypes.RSSI)}><Typography variant="h6" color="textSecondary">RSSI</Typography></Button></Grid>
                            </Grid>
                        ) : null
                    }
                    disableTypography={true}
                />
                <CardContent>
                    {
                        view === viewState.DASHBOARD ? (
                            ticketType === ticketTypes.GENERAL ? (
                                <Tickets profile={profile} responsive={responsive} openReport={setFileExplorerData} />
                            ) : ticketType === ticketTypes.RSSI ? (
                                <RSSITickets profile={profile} responsive={responsive} openReport={setFileExplorerData} />
                            ) : null
                        ) : null
                    }
                    {view === viewState.CREATE_NEW_TICKET_VIEW && !readOnly ? <CreateNewTicket profile={profile} responsive={responsive} back={() => setView(viewState.DASHBOARD)} /> : null}
                </CardContent>
            </Card>
            {Object.keys(fileExplorerData).length !== 0 ? <FileExplorer responsive={responsive} ticket={fileExplorerData} closeReport={() => setFileExplorerData({})} /> : null}
        </React.Fragment>
    )
}

export default HomePage
